module.exports = __webpack_public_path__ + "static/media/1 08 herverk.b0f6def3.mp3";